import { render, staticRenderFns } from "./ApprovalDetails.vue?vue&type=template&id=d873143c&scoped=true&"
import script from "./ApprovalDetails.vue?vue&type=script&lang=js&"
export * from "./ApprovalDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalDetails.vue?vue&type=style&index=0&id=d873143c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d873143c",
  null
  
)

export default component.exports